
import { Component, Vue } from 'vue-property-decorator';
import OsSheetContent from '@/components/core/sheet/OsSheetContent.vue';
import OsSheet from '@/components/core/sheet/OsSheet.vue';
@Component({
  components: { OsSheet, OsSheetContent }
})
export default class ExternalTargetProfile extends Vue {}
